import React, { Children, SyntheticEvent, useState } from 'react';

import { Avatar, Box, Divider, Tab, Tabs } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { selectCurrentBoundary } from 'state/userAdminSlices';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { StlAvatarChip } from 'features/common/StlChip';
import { background_gray_light_2 } from 'theme/cemTheme';

import styles from './ProjectTabs.module.css';

interface ITabPanel {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: ITabPanel) {
  const { children, value, index } = props;

  return (
    <div
      className={styles.tabPanel}
      role="tabpanel"
      hidden={value !== index}
      id={`pr-tabpanel-${index}`}
      aria-labelledby={`pr-tab-${index}`}
    >
      {value === index && children}
    </div>
  );
}

const TAB_BOUNDARY = 'Project Boundary';
const TAB_EVENTS = 'Special Events';

export function ProjectTabs({
  children,
  version = 'request',
  initialTab = 0,
}: {
  children: React.ReactNode[] | React.ReactNode;
  version?: 'request' | 'detail';
  initialTab?: number;
}) {
  const boundary = useAppSelector(selectCurrentBoundary);
  const [tabValue, setTabValue] = useState<number>(initialTab);

  const panels = Children.toArray(children);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  return (
    <>
      <Box className={styles.tabsWrapper}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="pr-tabs"
          className={styles.tabs}
          TabIndicatorProps={{ style: { display: 'none' } }}
        >
          <Tab
            value={0}
            disableRipple
            label={
              <StlAvatarChip
                active={tabValue === 0}
                txt={TAB_BOUNDARY}
                avatar={
                  version === 'detail' ? undefined : boundary &&
                    tabValue !== 0 ? (
                    <Avatar key="check">
                      <FontAwesomeIcon
                        name="check"
                        sx={{ color: background_gray_light_2 }}
                        size="0.75rem"
                      />
                    </Avatar>
                  ) : (
                    <Avatar>1</Avatar>
                  )
                }
              />
            }
            id="pr-tab-0"
            aria-controls="pr-tabpanel-0"
          />
          <Tab
            value={1}
            disableRipple
            label={
              <StlAvatarChip
                active={tabValue === 1}
                txt={
                  <>
                    <span>{TAB_EVENTS}</span>{' '}
                    {version === 'request' && (
                      <span style={{ fontWeight: 400 }}>(Optional)</span>
                    )}
                  </>
                }
                avatar={version === 'detail' ? undefined : <Avatar>2</Avatar>}
              />
            }
            id="pr-tab-1"
            aria-controls="pr-tabpanel-1"
          />
        </Tabs>
      </Box>
      <Divider />
      {panels.map((body, i) => (
        <TabPanel value={tabValue} index={i} key={i}>
          {tabValue === i ? body : null}
        </TabPanel>
      ))}
    </>
  );
}
